import { VxTreeOptions, VxTreeParser } from './parser.js';
import { VxTreeView } from './tree.js';
import { normalizeRef } from './util.js';

export const VX_DOM_SYMBOL = Symbol('vx:dom');
export const VX_TREE_SYMBOL = Symbol('vx:tree');
export const VX_LAST_REFS_SYMBOL = Symbol('vx:lastRefs');

export async function captureSnapshot(options: VxTreeOptions = {}) {
    const parser = new VxTreeParser(options);
    parser.parse();
    const domMap = parser.getDomMap();
    const vxTree = parser.getTree();
    (globalThis as any)[VX_DOM_SYMBOL] = domMap;
    (globalThis as any)[VX_TREE_SYMBOL] = vxTree;
    return vxTree;
}

export function getSnapshot(): VxTreeView {
    const vxTree = (globalThis as any)[VX_TREE_SYMBOL] as VxTreeView;
    if (!vxTree) {
        throw new Error('[VX] Snapshot not found');
    }
    return vxTree;
}

export function resolveDomNode(ref: string): Node | null {
    const domMap = (globalThis as any)[VX_DOM_SYMBOL] as Map<string, Node>;
    if (!domMap) {
        return null;
    }
    const normalizedRef = normalizeRef(ref);
    return domMap.get(normalizedRef) ?? null;
}
